const WhiteButtonComp = ({
   btnBoxSize = {},
   btnText,
   onClick = () => {},
   fullWidth = false,
   loading = false,
   id = "new-btn",
   autoFocus = false,
}) => {
   return (
      <button
         id={id}
         autoFocus={autoFocus}
         onClick={onClick}
         width={fullWidth ? "100%" : "btnBoxSize"}
         className={`vtwo-center-flex ${btnBoxSize}`}
      >
         {loading ? <div style={{ width: "2.5rem", height: "2.5rem" }} className="spinner-border"></div> : btnText}
      </button>
   );
};

export default WhiteButtonComp;
